import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useQuery as useQueryParams } from '@kiper/hooks';
import propTypes from 'prop-types';
import chroma from 'chroma-js';
import * as S from './styles';

const ActionButton = ({ primaryColor }) => {
  const [t] = useTranslation('personalized-invite');
  const theme = useTheme();
  const history = useHistory();
  const querystring = useQueryParams();
  const guestHash = querystring?.get('q')?.replace(/ /g, '+') || '';

  const textColor =
    chroma.contrast(primaryColor, theme.colors.white) > 3.5
      ? theme.colors.white
      : theme.colors.highBlack;

  const handleClick = () => {
    history.push(`/convite-personalizado/cadastro-facial?q=${guestHash}`);
  };

  return (
    <S.ButtonContainer>
      <S.Button
        primaryColor={primaryColor}
        textColor={textColor}
        onClick={handleClick}
      >
        <S.ButtonIconWrapper>
          <S.ButtonIcon size={24} color={textColor} />
        </S.ButtonIconWrapper>
        <S.ButtonTexts>
          <S.ButtonText>{t('register-face-and-unlock')}</S.ButtonText>
          <S.ButtonSubtitle>{t('register-face-subtitle')}</S.ButtonSubtitle>
        </S.ButtonTexts>
        <S.ArrowIcon color={textColor} size={24} />
      </S.Button>
    </S.ButtonContainer>
  );
};

ActionButton.propTypes = {
  primaryColor: propTypes.string.isRequired,
};

export default ActionButton;
